/**
 * @file App.tsx
 * @description
 *   The main entry point for the Negotiation Buddy Web Application. This file sets up the application layout,
 *   authentication wrapper, header, and routing logic. It uses React Router for navigation and MSAL for authentication.
 *   Protected routes are wrapped with the AuthWrapper and ProtectedRoute components to ensure only authenticated users
 *   can access certain pages. The routes are dynamically generated from the routesConfig file.
 *
 * @example
 *   import App from './App';
 *   // Used as the root component in index.tsx
 *
 * @exports
 *   App - The root React component for the application.
 */

import React from "react";
import "./App.css";
import Header from "./components/Header/header";
import { Routes, Route, Navigate } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import ProtectedRoute from "./hoc/ProtectedRoute";
import routes from "./config/routesConfig";
import AuthWrapper from "./hoc/AuthWrapper";

function App() {
  const isAuthenticated = useIsAuthenticated();
  return (
    <div>
      <AuthWrapper>
        {isAuthenticated && <Header />}
        <div className="main-container">
          <Routes>
            {routes.map((route) =>
              route.protected ? (
                <Route
                  key={route.path}
                  path={route.path}
                  element={<ProtectedRoute>{route.element}</ProtectedRoute>}
                />
              ) : (
                <Route
                  key={route.path}
                  path={route.path}
                  element={route.element}
                />
              )
            )}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </AuthWrapper>
    </div>
  );
}

export default App;
